
        import * as module0 from './bundle/facebook.png';import * as module1 from './bundle/google.png';import * as module2 from './bundle/instagram.png';import * as module3 from './bundle/seznam.png'

        const modules = [module0,module1,module2,module3];

        export default modules;
        export const filenames = ['./bundle/facebook.png','./bundle/google.png','./bundle/instagram.png','./bundle/seznam.png']
      